import React, { Component } from 'react'
import { connect } from 'react-redux'

import Comments from 'components/Comments'
import Attachments from 'components/Attachments'

import { attachmentPath } from 'selectors/attachments'

import { MentionsInput, Mention } from 'react-mentions'

let select = (state, props) => ({
	path: attachmentPath(state, props.projectID)
})
export class RightSide extends Component{
	render(){
		let oneColomn = this.props.countColomns == 1
		return(
			<div className="rightSide"
				style={{
					width: (this.props.countColomns>1)?"50%":"100%"
				  , clear:"both"
					, paddingLeft:"5px"
				  , position: "relative"
				  , display: "block"
				  , overflowY: "hidden"
				  , paddingBottom: "50px"
				}}
			>
				<div className="wrapper"
					style={{
						paddingBottom: "70px"
					  , overflow:"hidden"
					  , minHeight: !oneColomn?"calc(100vh - 64px)":"0"
					  , borderLeft: !oneColomn? "1px solid rgba(0,0,0,0.3)" : "none"
					}}
				>
					<Attachments objectID={this.props.projectID} path={this.props.path} removable={true} top={true}/>
					<Comments objectID={this.props.projectID} path={this.props.path} />
				</div>

			</div>
		)
	}
}

export default connect(select)(RightSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/projectForm/RightSide.js